import {
  Box,
  Button,
  Checkbox,
  Divider,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  Image,
  useToast,
  Link,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { PostCardProps, WishlistItemProps } from '../interfaces/components';
import { LoccitaneClose } from '../Icons/LoccitaneClose';
import PostCardOneImage from '../assets/images/PostCardOne.png';
import PostCardTwoImage from '../assets/images/PostCardTwo.png';
import PostCardThreeImage from '../assets/images/PostCardThree.png';
import PostCardFourImage from '../assets/images/PostCardFour.png';
import WishlistProduct from '../components/common/WishlistProduct';
import ChooseText from '../components/PostCard/ChooseText';
import ChoosePattern from '../components/PostCard/ChoosePattern';
import LoccitaneLogoEN from '../assets/images/LoccitaneLogoEN.png';
import { PostCardModal } from '../content';
import { dispatchCTAClickObject } from '../Analytics';
import axios from 'axios';
import { returnLoccitaneLocale } from '../utils/helper';

const PostCard = ({ wishlistProducts, activeLocale, active, setActive, removeFromWishlist }: PostCardProps) => {
  const [recipientName, setRecipientName] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('');
  const [senderEmail, setSenderEmail] = useState('');
  const [yourName, setYourName] = useState('');
  const [chosenText, setChosenText] = useState(0);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [chosenPattern, setChosenPattern] = useState(PostCardOneImage);
  const toast = useToast();

  const sendPostcard = () => {
    let emailStyle = '';
    let bgImage = '';
    const wishlistProductIds: string[] = [];

    wishlistProducts.forEach((wishlistProduct: WishlistItemProps) =>
      wishlistProductIds.push(wishlistProduct.product_id),
    );

    const redirectUrl =
      'https://ae.loccitane.com/emperia_holiday.html?lang=' +
      returnLoccitaneLocale(window.locale) +
      '&ids=' +
      wishlistProductIds.join(',');

    console.log(redirectUrl);

    if (chosenText === 0) {
      if (activeLocale === 'ar') {
        emailStyle = 'LoccitaneXmas2023StyleOneAR';
      } else {
        emailStyle = 'LoccitaneXmas2023StyleOneEN';
      }
    } else if (chosenText === 1) {
      if (activeLocale === 'ar') {
        emailStyle = 'LoccitaneXmas2023StyleTwoAR';
      } else {
        emailStyle = 'LoccitaneXmas2023StyleTwoEN';
      }
    } else if (chosenText === 2) {
      if (activeLocale === 'ar') {
        emailStyle = 'LoccitaneXmas2023StyleThreeAR';
      } else {
        emailStyle = 'LoccitaneXmas2023StyleThreeEN';
      }
    }

    if (chosenPattern === PostCardOneImage) {
      bgImage = 'https://emperia-static.s3.eu-west-2.amazonaws.com/Loccitane/EmailAssets/PostCardOne.png';
    } else if (chosenPattern === PostCardFourImage) {
      bgImage = 'https://emperia-static.s3.eu-west-2.amazonaws.com/Loccitane/EmailAssets/PostCardFour.png';
    } else if (chosenPattern === PostCardThreeImage) {
      bgImage = 'https://emperia-static.s3.eu-west-2.amazonaws.com/Loccitane/EmailAssets/PostCardThree.png';
    } else if (chosenPattern === PostCardTwoImage) {
      bgImage = 'https://emperia-static.s3.eu-west-2.amazonaws.com/Loccitane/EmailAssets/PostCardTwo.png';
    }
    dispatchCTAClickObject('loccitane', 'button', 'postCard', 'Send', '');

    const postCardConfig = {
      additional_info: { sender: senderEmail },
      args: {
        recipientName: recipientName,
        senderName: yourName,
        products: wishlistProducts,
        bgImage: bgImage,
        redirectUrl: redirectUrl,
      },
      experience_name: 'loccitane-xmas',
      org_name: 'loccitane',
      recepients: [recipientEmail],
      subject: 'Loccitane Xmas Holiday',
      template_key: emailStyle,
    };

    console.log(postCardConfig);

    setSendingEmail(true);
    axios
      .post(
        'https://yclpfhfqe8.execute-api.us-east-1.amazonaws.com/development/api/email/send_instant_email',
        postCardConfig,
      )
      .then((res) => {
        console.log(res);

        toast({
          position: 'top',
          title: 'Email Submitted.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        setSendingEmail(false);
        setActive();
        setTimeout(() => {
          setRecipientEmail('');
          setRecipientName('');
          setYourName('');
          setSenderEmail('');
          setChosenPattern(PostCardOneImage);
          setChosenText(0);
        }, 500);
      })
      .catch((err) => {
        console.log(err);

        toast({
          position: 'top',
          title: 'Error Sending Postcard, Try Again',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        setSendingEmail(false);
      });
  };

  const getTextOption = (optionNumber: number) => {
    const textOptions = [
      {
        template: (
          <Box>
            <Box display="flex" w="100%" lang={activeLocale === 'ar' ? 'ar' : 'en'} dir="auto">
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optOne.textOnePre
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optOne.textOnePre}
              </Text>
              &nbsp;
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                textDecoration="underline"
                opacity="0.5"
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {recipientName.length > 0
                  ? recipientName + ','
                  : activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optOne.textOne
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optOne.textOne}
              </Text>
            </Box>

            <Text
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
              opacity="0.5"
              mt={['5px', '5px', '5px', '5px', '10px']}
              w="100%"
              textAlign={activeLocale === 'ar' ? 'right' : 'left'}
              fontSize={['15px', '15px', '15px', '15px', '16px']}
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                ? PostCardModal['en'].left.optOne.textTwo
                : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optOne.textTwo}
            </Text>

            <Box
              display="flex"
              mt={['5px', '5px', '5px', '5px', '10px']}
              w="100%"
              lang={activeLocale === 'ar' ? 'ar' : 'en'}
              dir="auto"
            >
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optOne.textThreeFirst
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optOne.textThreeFirst}
              </Text>
              &nbsp;
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                textDecoration="underline"
                opacity="0.5"
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {yourName.length > 0
                  ? yourName
                  : activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optOne.textThreeSecond
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optOne.textThreeSecond}
              </Text>
            </Box>
          </Box>
        ),
      },
      {
        template: (
          <Box>
            <Box display="flex" w="100%" lang={activeLocale === 'ar' ? 'ar' : 'en'} dir="auto">
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optTwo.textOnePre
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optTwo.textOnePre}
              </Text>
              &nbsp;
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                textDecoration="underline"
                opacity="0.5"
                textAlign={activeLocale === 'ar' ? 'right' : 'left'}
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {recipientName.length > 0
                  ? recipientName + ','
                  : activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optTwo.textOne
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optTwo.textOne}
              </Text>
            </Box>

            <Text
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
              opacity="0.5"
              mt={['5px', '5px', '5px', '5px', '10px']}
              w="100%"
              textAlign={activeLocale === 'ar' ? 'right' : 'left'}
              fontSize={['15px', '15px', '15px', '15px', '16px']}
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                ? PostCardModal['en'].left.optTwo.textTwo
                : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optTwo.textTwo}
            </Text>

            <Box
              display="flex"
              mt={['5px', '5px', '5px', '5px', '10px']}
              w="100%"
              lang={activeLocale === 'ar' ? 'ar' : 'en'}
              dir="auto"
            >
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optTwo.textThreeFirst
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optTwo.textThreeFirst}
              </Text>
              &nbsp;
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                textDecoration="underline"
                opacity="0.5"
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {yourName.length > 0
                  ? yourName
                  : activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optTwo.textThreeSecond
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optTwo.textThreeSecond}
              </Text>
            </Box>
          </Box>
        ),
      },
      {
        template: (
          <Box>
            <Box display="flex" w="100%" lang={activeLocale === 'ar' ? 'ar' : 'en'} dir="auto">
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optThree.textOnePre
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optThree.textOnePre}
              </Text>
              &nbsp;
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                opacity="0.5"
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {recipientName.length > 0
                  ? recipientName + ','
                  : activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optThree.textOne
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optThree.textOne}
              </Text>
            </Box>

            <Text
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
              opacity="0.5"
              mt={['5px', '5px', '5px', '5px', '10px']}
              w="100%"
              textAlign={activeLocale === 'ar' ? 'right' : 'left'}
              fontSize={['15px', '15px', '15px', '15px', '16px']}
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                ? PostCardModal['en'].left.optThree.textTwo
                : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optThree.textTwo}
            </Text>

            <Text
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
              opacity="0.5"
              mt={['5px', '5px', '5px', '5px', '10px']}
              w="100%"
              textAlign={activeLocale === 'ar' ? 'right' : 'left'}
              fontSize={['15px', '15px', '15px', '15px', '16px']}
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                ? PostCardModal['en'].left.optThree.textTwoSec
                : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optThree.textTwoSec}
            </Text>

            <Box
              display="flex"
              mt={['5px', '5px', '5px', '5px', '10px']}
              w="100%"
              lang={activeLocale === 'ar' ? 'ar' : 'en'}
              dir="auto"
            >
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optThree.textThreeFirst
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optThree.textThreeFirst}
              </Text>
              &nbsp;
              <Text
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                opacity="0.5"
                fontSize={['15px', '15px', '15px', '15px', '16px']}
              >
                {yourName.length > 0
                  ? yourName
                  : activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.optThree.textThreeSecond
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.optThree.textThreeSecond}
              </Text>
            </Box>
          </Box>
        ),
      },
    ];

    return textOptions[optionNumber];
  };

  return (
    <Modal onClose={() => !sendingEmail && setActive()} isOpen={active}>
      <ModalOverlay />
      <ModalContent
        display={['none', 'none', 'none', 'unset', 'unset']}
        borderRadius="0px"
        m="auto"
        h={['550px', '550px', '550px', '500px', '600px']}
        maxW="fit-content"
        width="auto"
        overflowX="hidden"
        position="fixed"
        top="0"
        left="0"
        bottom="0"
        right="0"
      >
        <LoccitaneClose
          position="absolute"
          top="25px"
          left="25px"
          boxSize={[6, 6, 8]}
          cursor="pointer"
          strokeWidth={0.5}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ filter: 'drop-shadow(-2px 0px 2px #FFF736) drop-shadow(2px 0px 4px #FFCB00)', stroke: 'black' }}
          transition=".5s"
          onClick={() => !sendingEmail && setActive()}
        />
        <ModalBody
          height={['500px', '500px', '500px', '500px', '550px']}
          pointerEvents={active ? 'all' : 'none'}
          padding="24px"
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          gap="5"
        >
          {/* Left */}
          <Box
            backgroundImage={`url(${chosenPattern})`}
            backgroundSize="cover"
            width={['unset', 'unset', 'unset', '600px', '700px']}
            h={['500px', '500px', '500px', '460px', '550px']}
            display="flex"
            flexDirection="column"
            position="relative"
          >
            <Box bg="white" w="100%" display="flex" justifyContent="center" alignItems="center" height={['60px']}>
              <Text
                fontSize={['20px', '20px', '20px', '20px', '25px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoMedium' : 'LoccitaneRegular'}
              >
                {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.heading
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.heading}
              </Text>
            </Box>
            <Box
              h="100%"
              bg="white"
              margin={['unset', 'unset', 'unset', '20px', '30px']}
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
            >
              <Box width={['unset', 'unset', 'unset', '310px', '330px']} h="300px">
                <Text
                  textTransform="uppercase"
                  color="#a8a8a8"
                  fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
                  fontSize={['15px']}
                  fontWeight="900"
                  h="50px"
                  m="0 auto"
                  w="auto"
                  textAlign="center"
                >
                  {yourName.length > 0
                    ? yourName + '’s'
                    : activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                    ? PostCardModal['en'].left.wishlistPre
                    : PostCardModal[activeLocale as keyof typeof PostCardModal].left.wishlistPre}
                  &nbsp;
                  <span style={{ color: 'black' }}>
                    {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                      ? PostCardModal['en'].left.wishlistName
                      : PostCardModal[activeLocale as keyof typeof PostCardModal].left.wishlistName}
                  </span>
                </Text>
                <Box h={['220px']} padding="0px" overflow="auto" lang={activeLocale === 'ar' ? 'ar' : 'en'} dir="auto">
                  {wishlistProducts &&
                    wishlistProducts?.map((wishlistProduct: WishlistItemProps) => (
                      <WishlistProduct
                        key={wishlistProduct.product_id}
                        activeLocale={activeLocale}
                        productImage={wishlistProduct.image}
                        productName={wishlistProduct.title}
                        productMetric={wishlistProduct.size}
                        productPrice={wishlistProduct.price}
                        productCurrency={wishlistProduct.currency}
                        removeFromWishlist={() => removeFromWishlist(wishlistProduct.product_id)}
                      />
                    ))}
                </Box>
              </Box>

              <Divider orientation="vertical" border="1px solid" borderColor="#EDE2D3" h="90%" />

              <Box
                width={['unset', 'unset', 'unset', '270px', '370px']}
                h={['100%']}
                p={['20px', '20px', '20px', '30px 20px', '25px']}
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                position="relative"
              >
                <Image
                  src={LoccitaneLogoEN}
                  position="absolute"
                  width={['90px', '90px', '90px', '80px', '90px']}
                  top="10px"
                  left={activeLocale === 'ar' ? '10px' : 'unset'}
                  right={activeLocale === 'ar' ? 'unset' : '10px'}
                />

                {getTextOption(chosenText).template}

                <Box
                  marginTop="auto"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  w="100%"
                >
                  <Box mb={['unset', 'unset', 'unset', '10px', '10px']}>
                    <Text
                      w="250px"
                      textAlign="center"
                      fontSize={['14px', '14px', '14px', '14px', '15px']}
                      fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                    >
                      {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                        ? PostCardModal['en'].left.topButtonTextOne
                        : PostCardModal[activeLocale as keyof typeof PostCardModal].left.topButtonTextOne}
                    </Text>
                    <Text
                      w="250px"
                      textAlign="center"
                      fontSize={['14px', '14px', '14px', '14px', '15px']}
                      fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                    >
                      {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                        ? PostCardModal['en'].left.topButtonTextTwo
                        : PostCardModal[activeLocale as keyof typeof PostCardModal].left.topButtonTextTwo}
                    </Text>
                  </Box>
                  <Button
                    bg="#FFCB00"
                    borderRadius="0px"
                    w="100%"
                    height={['50px', '50px', '50px', '40px', '50px']}
                    fontSize={['14px', '14px', '14px', '14px', '15px']}
                    _hover={{ bg: 'rgb(255, 203, 0, 0.4)' }}
                    _focus={{ bg: '#FFCB00' }}
                    onClick={() => console.log('Sub')}
                    fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
                    textTransform="uppercase"
                  >
                    {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                      ? PostCardModal['en'].left.button
                      : PostCardModal[activeLocale as keyof typeof PostCardModal].left.button}
                  </Button>
                </Box>
              </Box>
            </Box>

            <Box bg="white" w="100%" display="flex" justifyContent="center" alignItems="center" height={['60px']}>
              <Text
                fontSize={['18px', '18px', '18px', '18px', '20px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
              >
                {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].left.preview
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].left.preview}
              </Text>
            </Box>
          </Box>

          {/* Right */}
          <Box
            h={['500px', '500px', '500px', '450px', '550px']}
            overflow="auto"
            w="300px"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            padding="20px"
            outline="4px  solid #FFCB00"
          >
            <Text
              fontSize={['18px', '18px', '18px', '17px', '18px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoMedium' : 'LoccitaneRegular'}
              m="0 auto"
              textAlign="center"
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                ? PostCardModal['en'].right.heading
                : PostCardModal[activeLocale as keyof typeof PostCardModal].right.heading}
            </Text>
            <Box>
              <Text
                fontSize={['15px', '15px', '15px', '15px', '16px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
                textAlign={activeLocale === 'ar' ? 'right' : 'left'}
              >
                {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].right.subHeading
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].right.subHeading}
              </Text>
              <Box>
                <Input
                  fontSize={['15px', '15px', '15px', '15px', '16px']}
                  variant="flushed"
                  placeholder={
                    activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                      ? PostCardModal['en'].right.recpName
                      : PostCardModal[activeLocale as keyof typeof PostCardModal].right.recpName
                  }
                  fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                  textAlign={activeLocale === 'ar' ? 'right' : 'left'}
                  _focusVisible={{ borderBottom: '2px solid #FFCB00' }}
                  value={recipientName}
                  onChange={(e) => setRecipientName(e.target.value)}
                  lang={activeLocale === 'ar' ? 'ar' : 'en'}
                  dir="auto"
                />
                <Input
                  fontSize={['15px', '15px', '15px', '15px', '16px']}
                  variant="flushed"
                  placeholder={
                    activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                      ? PostCardModal['en'].right.recpEmail
                      : PostCardModal[activeLocale as keyof typeof PostCardModal].right.recpEmail
                  }
                  fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                  textAlign={activeLocale === 'ar' ? 'right' : 'left'}
                  _focusVisible={{ borderBottom: '2px solid #FFCB00' }}
                  value={recipientEmail}
                  onChange={(e) => setRecipientEmail(e.target.value)}
                  lang={activeLocale === 'ar' ? 'ar' : 'en'}
                  dir="auto"
                />
              </Box>
              <Box mt={['20px', '20px', '20px', '20px', '25px']}>
                <Input
                  fontSize={['15px', '15px', '15px', '15px', '16px']}
                  variant="flushed"
                  placeholder={
                    activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                      ? PostCardModal['en'].right.yourName
                      : PostCardModal[activeLocale as keyof typeof PostCardModal].right.yourName
                  }
                  fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                  _focusVisible={{ borderBottom: '2px solid #FFCB00' }}
                  textAlign={activeLocale === 'ar' ? 'right' : 'left'}
                  value={yourName}
                  onChange={(e) => setYourName(e.target.value)}
                  lang={activeLocale === 'ar' ? 'ar' : 'en'}
                  dir="auto"
                />
                <Input
                  fontSize={['15px', '15px', '15px', '15px', '16px']}
                  variant="flushed"
                  placeholder={
                    activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                      ? PostCardModal['en'].right.yourEmail
                      : PostCardModal[activeLocale as keyof typeof PostCardModal].right.yourEmail
                  }
                  fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
                  textAlign={activeLocale === 'ar' ? 'right' : 'left'}
                  _focusVisible={{ borderBottom: '2px solid #FFCB00' }}
                  value={senderEmail}
                  onChange={(e) => setSenderEmail(e.target.value)}
                  lang={activeLocale === 'ar' ? 'ar' : 'en'}
                  dir="auto"
                />
              </Box>
            </Box>

            <Box>
              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                flexDirection={activeLocale === 'ar' ? 'row-reverse' : 'row'}
              >
                <Text
                  fontSize={['15px', '15px', '15px', '15px', '16px']}
                  fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
                >
                  {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                    ? PostCardModal['en'].right.chooseText
                    : PostCardModal[activeLocale as keyof typeof PostCardModal].right.chooseText}
                </Text>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexDirection={activeLocale === 'ar' ? 'row-reverse' : 'row'}
                  width="80px"
                  m={['0px 10px']}
                >
                  <ChooseText
                    activeLocale={activeLocale}
                    bgColor="#CCCCCC"
                    chosen={chosenText === 0 ? true : false}
                    content="1"
                    setActive={() => setChosenText(0)}
                  />
                  <ChooseText
                    activeLocale={activeLocale}
                    bgColor="#CCCCCC"
                    chosen={chosenText === 1 ? true : false}
                    content="2"
                    setActive={() => setChosenText(1)}
                  />
                  <ChooseText
                    activeLocale={activeLocale}
                    bgColor="#CCCCCC"
                    chosen={chosenText === 2 ? true : false}
                    content="3"
                    setActive={() => setChosenText(2)}
                  />
                </Box>
              </Box>

              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                mt={['15px']}
                flexDirection={activeLocale === 'ar' ? 'row-reverse' : 'row'}
              >
                <Text
                  fontSize={['15px', '15px', '15px', '15px', '16px']}
                  fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
                >
                  {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                    ? PostCardModal['en'].right.choosePattern
                    : PostCardModal[activeLocale as keyof typeof PostCardModal].right.choosePattern}
                </Text>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  width="100px"
                  flexDirection={activeLocale === 'ar' ? 'row-reverse' : 'row'}
                  m={['0px 10px']}
                >
                  <ChoosePattern
                    activeLocale={activeLocale}
                    bgColor="#4918A0"
                    chosen={chosenPattern === PostCardOneImage ? true : false}
                    setActive={() => setChosenPattern(PostCardOneImage)}
                  />

                  <ChoosePattern
                    activeLocale={activeLocale}
                    bgColor="#FA7598"
                    chosen={chosenPattern === PostCardFourImage ? true : false}
                    setActive={() => setChosenPattern(PostCardFourImage)}
                  />

                  <ChoosePattern
                    activeLocale={activeLocale}
                    bgColor="#FDC506"
                    chosen={chosenPattern === PostCardThreeImage ? true : false}
                    setActive={() => setChosenPattern(PostCardThreeImage)}
                  />

                  <ChoosePattern
                    activeLocale={activeLocale}
                    bgColor="#22D8C2"
                    chosen={chosenPattern === PostCardTwoImage ? true : false}
                    setActive={() => setChosenPattern(PostCardTwoImage)}
                  />
                </Box>
              </Box>
            </Box>

            <Box>
              <Button
                disabled={sendingEmail}
                bg="#FFCB00"
                borderRadius="0px"
                w="100%"
                height="50px"
                fontSize={['14px', '14px', '14px', '14px', '15px']}
                _hover={{ bg: 'rgb(255, 203, 0, 0.4)' }}
                _focus={{ bg: '#FFCB00' }}
                onClick={() => !sendingEmail && sendPostcard()}
                fontFamily={activeLocale === 'ar' ? 'GETwoMedium' : 'RalewayMedium'}
                textTransform="uppercase"
              >
                {sendingEmail
                  ? activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                    ? PostCardModal['en'].right.buttonSending
                    : PostCardModal[activeLocale as keyof typeof PostCardModal].right.buttonSending
                  : activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                  ? PostCardModal['en'].right.button
                  : PostCardModal[activeLocale as keyof typeof PostCardModal].right.button}
              </Button>

              <Checkbox defaultChecked mt="15px" colorScheme="yellow">
                <Text fontSize={['10px']} fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}>
                  {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                    ? PostCardModal['en'].right.tandc
                    : PostCardModal[activeLocale as keyof typeof PostCardModal].right.tandc}
                  &nbsp;
                  <Link
                    href="https://ae.loccitane.com/terms_and_conditions/terms.html?lang=en_AE"
                    color="yellow.500"
                    target="_blank"
                  >
                    {activeLocale === undefined || !((activeLocale as keyof typeof PostCardModal) in PostCardModal)
                      ? PostCardModal['en'].right.tandcLink
                      : PostCardModal[activeLocale as keyof typeof PostCardModal].right.tandcLink}
                  </Link>
                </Text>
              </Checkbox>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PostCard;
